import pluralize from 'pluralize';

export default (value, count) => {
  return pluralize(value, count);
}
